module.exports = __webpack_public_path__ + "img/9_118.413e71c9.png";